/**
 * Generates completion time text based on weeks to complete
 * @param weeksToComplete - Number of weeks to complete the course/program
 * @param includeToComplete - Whether to include "to complete" in the text (default: true)
 * @returns Formatted completion time text or null if data is not available
 */
export function getCompletionTimeText(
  weeksToComplete?: number,
  includeToComplete: boolean = true,
): string | null {
  if (!weeksToComplete || weeksToComplete <= 0) return null;

  const suffix = includeToComplete ? " to complete" : "";

  // Show weeks if 8 weeks or less, months if higher than 8 weeks
  if (weeksToComplete <= 8) {
    return `${weeksToComplete} week${weeksToComplete !== 1 ? "s" : ""}${suffix}`;
  } else {
    const months = Math.ceil(weeksToComplete / 4);
    return `${months} month${months !== 1 ? "s" : ""}${suffix}`;
  }
}
